import { createApp } from 'vue';
import Pagination from "./Pagination.vue";

const els = document.querySelectorAll(".js-pagination");
els.forEach((el) => {
  const app = createApp(Pagination, {
    basePath: JSON.parse(el.dataset.basePath),
    currentPage: Number(el.dataset.currentPage),
    firstUrl: JSON.parse(el.dataset.firstUrl),
    lastUrl: JSON.parse(el.dataset.lastUrl),
    nextUrl: JSON.parse(el.dataset.nextUrl),
    pages: JSON.parse(el.dataset.pages),
    pageTrigger: JSON.parse(el.dataset.pageTrigger),
    prevUrl: JSON.parse(el.dataset.prevUrl),
    totalPages: Number(el.dataset.totalPages)
  });
  app.mount(el);
})